import Vue from 'vue'
import Vuex from 'vuex'
import toastr from 'toastr'
import axios from 'axios'
import support from './support.json'
// import router from '@/router'

Vue.use(toastr)
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    initData: null,
    loading: false,
    loadingTable: false,
    loadingSubmit: false,
    error: null,
    docTypes: null,
    roleFilterStatus: null,
    userSignsData: null,
    otherData: {},
    itineraryNo: null,
    detailHs: null,
    maritimeCode: '',
    selectTauRoi: {},
    selectPTTND: {},
    selectTau: {},
    keHoachDen: {},
    totalTauDiChuyen: 0,
    itemFee: {},
    counterThongBaoPhi: 0,
    counterDaXuLy: 0,
    switch1: false,
    pttnd: false,
    noiChuyenlai: false,
    drawer: true
  },
  actions: {
    clearError ({commit}) {
      commit('clearError')
    },
    loadInitResource ({commit, state}) {
      if (state.initData == null) {
        return new Promise(function (resolve, reject) {
          let param = {}
          let orginURL = window.location.href
          let coma = window.location.href.lastIndexOf('#/')
          if (coma > 0) {
            orginURL = window.location.href.substr(0, coma)
          }
          var url1 = new Promise(function (resolve, reject) {
            axios.get(orginURL + support.renderURLInit, param).then(function (response) {
              let serializable = response.data
              resolve(serializable)
            }).catch(function (error) {
              console.log(error)
              reject(error)
            })
          })
          var url2 = new Promise(function (resolve, reject) {
            axios.get(orginURL + support.renderURLInit2, param).then(function (response) {
              let serializable = response.data
              if (serializable && serializable['user']) {
                let user = serializable['user']
                commit('setMaritimeCode', user['maritimeCode'])
              } else {
                commit('setMaritimeCode', '')
              }
              resolve(serializable)
            }).catch(function (error) {
              console.log(error)
              reject(error)
            })
          })
          var url3 = new Promise(function (resolve, reject) {
            axios.get(orginURL + support.renderURLInit3, param).then(function (response) {
              let serializable = response.data
              resolve(serializable)
            }).catch(function (error) {
              console.log(error)
              reject(error)
            })
          })
          Promise.all([url1, url2, url3]).then(function (results) {
            var data = Object.assign(results[0], results[1], results[2])
            commit('setInitData', data)
            resolve(data)
          }).catch(function (xhr) {
            commit('setInitData', null)
            reject(null)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve(state.initData)
        })
      }
    },
    loadHomeDataTable ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          if (data.type === 'ke_hoach') {
            param.params['requestState'] = data.documentStatusCode
          } else if (data.type === 'thu_tuc') {
            param.params['documentStatusCode'] = data.documentStatusCode
          }
          param.params['isDTND'] = state.initData.user.isDTND
          param.params['isDTNDCam'] = state.initData.user.isDTNDCam
          let urlRequest = ''
          if (data.type === 'ke_hoach') {
            urlRequest = state.initData.getHoSoKeHoachTable
          } else if (data.type === 'thu_tuc') {
            urlRequest = state.initData.getHoSoThuTucTable
          } else if (data.type === 'lanh_dao') {
            urlRequest = state.initData.getHistoryTable
            param.params['documentTypeCode'] = 'document_sign'
          } else if (data.type === 'van_thu') {
            urlRequest = state.initData.getHistoryTable
            param.params['documentTypeCode'] = 'document_approve'
          } else {
            urlRequest = state.initData.getHoSoKeHoachTable
          }
          axios.get(urlRequest, param).then(function (response) {
            let serializable = response.data
            console.log(serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    genCertificateNo ({commit, state}, data) {
      let param = {
        params: data
      }
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.genCertificateNoURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    genDocumentaryCode ({commit, state}, data) {
      let param = {
        params: data
      }
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.genDocumentaryCodeURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    genDocumentNameVoy ({commit, state}, data) {
      let param = {
        params: data
      }
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.genDocumentNameVoyURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getSoChuyen ({commit, state}, data) {
      let param = {
        params: data
      }
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getNumberOfArrivalDepartureInMonthURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    vmaScheduleShiftingExport ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['vmaScheduleShiftingExportURL'], param).then(function (response) {
            var url = response.data['urlDownload'] || ''
            resolve(url)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    inKeHoachDieuDongTheoNgay ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['exportVmaScheduleAnchoragePortURL'], param).then(function (response) {
            var url = response.data['urlDownload'] || ''
            resolve(url)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    keHoachDieuDongExport ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['keHoachDieuDongExportURL'], param).then(function (response) {
            var url = response.data['url'] || ''
            resolve(url)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    yeuCauGiayPhepVaoRoiExport ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['yeuCauGiayPhepVaoRoiExportURl'], param).then(function (response) {
            var url = response.data['url'] || ''
            resolve(url)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    vmaItineraryScheduleExport ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['vmaItineraryScheduleExportURL'], param).then(function (response) {
            var url = response.data['urlDownload'] || ''
            resolve(url)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xemThongBaoVaoRoiCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data,
            responseType: 'blob'
          }
          axios.get(state.initData['xemThongBaoVaoRoiCang'], param).then(function (response) {
            var url = window.URL.createObjectURL(response.data)
            resolve({
              url: url
            })
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xemThongBaoThuPhi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data,
            responseType: 'blob'
          }
          axios.get(state.initData['xemThongBaoThuPhi'], param).then(function (response) {
            var url = window.URL.createObjectURL(response.data)
            resolve({
              url: url
            })
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xemLichSuVaoRoi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data,
            responseType: 'blob'
          }
          axios.get(state.initData['historyComeOut'], param).then(function (response) {
            var url = window.URL.createObjectURL(response.data)
            resolve({
              url: url
            })
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    printPreviewPdf ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let query = {}
          for (var key in data) {
            if (key !== 'urlKey') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query,
            responseType: 'blob'
          }
          axios.get(state.initData[data['urlKey']], param).then(function (response) {
            var url = response.data['url'] || ''
            resolve(url)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getScheduleAnchorageDuration ({commit, state}, data) {
      let param = {
        params: data
      }
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getVmaScheduleAnchoragePaymentDurationURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadWarningCauCang ({commit, state}, data) {
      let param = {
        params: data
      }
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.warningPortWharf, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadWarningPilot ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.warningPilot, data).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadWarningTugboat ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.warningTugboat, data).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadWarning ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getWarningURL, data).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadThanhPhanTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getThanhPhanTauBien, data).then(function (response) {
            let serializable = response.data
            console.log(serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    countDanhSachTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let urlRequest = data.url
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          axios.get(urlRequest, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    countDanhSachThanhToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let urlRequest = data.url
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          axios.get(urlRequest, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDsHangHoa ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          axios.get(state.initData['getVmaScheduleCargolistURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDsNeoDau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          axios.get(state.initData['getVmaScheduleAnchorage_Port_URL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDanhSachTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let urlRequest = data.url
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          if (data['getShip']) {
            param['timeout'] = 35000
          }
          axios.get(urlRequest, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    dsTBPTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          if (!data) {
            data = {}
          }
          let param = {
            params: {
              ...data
            }
          }
          axios.get(state.initData['dsTBPTauBienURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    dsTBPPTTND ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          if (!data) {
            data = {}
          }
          let param = {
            params: {
              ...data
            }
          }
          axios.get(state.initData['dsTBPPTTNDURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDanhSachThanhToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          // if (data.type === 'ke_hoach') {
          //   param.params['requestState'] = data.documentStatusCode
          // } else if (data.type === 'thu_tuc') {
          //   param.params['documentStatusCode'] = data.documentStatusCode
          // }
          // param.params['isDTND'] = state.initData.user.isDTND
          // param.params['isDTNDCam'] = state.initData.user.isDTNDCam
          let urlRequest = data.url
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          axios.get(urlRequest, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadHoSoChuyenTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['findVmaItineraryScheduleByItineraryNoURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    findUserPortByUserId ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['findUserPortByUserIdURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadInitDepartmentCode ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['getDepartmentCodeByUserId'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDsTauVao ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['dsNoiChuyenURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDsTauRoi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['findVmaItineraryScheduleURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDsTempDocument ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData['findTempDocumentURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    inPhieuThanhToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query
          }
          axios.get(state.initData.excelBienLaiThuPhi, param).then(function (response) {
            resolve(response.data)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    exportDanhSachTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          // if (data.type === 'ke_hoach') {
          //   param.params['requestState'] = data.documentStatusCode
          // } else if (data.type === 'thu_tuc') {
          //   param.params['documentStatusCode'] = data.documentStatusCode
          // }
          // param.params['isDTND'] = state.initData.user.isDTND
          // param.params['isDTNDCam'] = state.initData.user.isDTNDCam
          let urlRequest = data.url
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query,
            responseType: 'blob'
          }
          axios.get(urlRequest, param).then(function (response) {
            var url = window.URL.createObjectURL(response.data)
            resolve({
              url: url,
              fileName: response.headers['file-name']
            })
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    exportDanhSachThanhToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          // if (data.type === 'ke_hoach') {
          //   param.params['requestState'] = data.documentStatusCode
          // } else if (data.type === 'thu_tuc') {
          //   param.params['documentStatusCode'] = data.documentStatusCode
          // }
          // param.params['isDTND'] = state.initData.user.isDTND
          // param.params['isDTNDCam'] = state.initData.user.isDTNDCam
          let urlRequest = data.url
          let query = {}
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key]
            }
          }
          let param = {
            params: query,
            responseType: 'blob'
          }
          axios.get(urlRequest, param).then(function (response) {
            var url = window.URL.createObjectURL(response.data)
            resolve({
              url: url,
              fileName: response.headers['file-name']
            })
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadLenhDieuDongEXT ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData.getLenhDieuDongEXT, param).then(function (response) {
            let serializable = response.data
            console.log(serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadHomeDataPaymentTable ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          let url = ''
          if (result['user'] && result['user'].isKeToan) {
            url = state.initData.getPaymentData
          } else {
            url = state.initData.getPaymentDataPublicURL
          }
          axios.get(url, param).then(function (response) {
            let serializable = response.data
            console.log(serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDocTypes ({commit, state}) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getDocTypes).then(function (response) {
            let serializable = response.data
            commit('setDocTypes', serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadRoleFilterStatus ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              documentType: filter.documentType
            }
          }
          axios.get(state.initData.getRoleFilterStatus, param).then(function (response) {
            let serializable = response.data
            commit('setRoleFilterStatus', serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailGiuTau ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleSecurityId': filter.id
            }
          }
          axios.get(state.initData.getVmaScheduleSecurity_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailHaXuong ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleLaunchingId': filter.id
            }
          }
          axios.get(state.initData.getVmaScheduleLaunching_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailChuyenTuyen ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleXlineSailingId': filter.id
            }
          }
          axios.get(state.initData.getVmaScheduleXlineSailing_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getVmaitineraryRemarks ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: filter
          }
          axios.get(state.initData.getVmaitineraryRemarksURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailSuaChua ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleShipyardId': filter.id
            }
          }
          axios.get(state.initData.getVmaScheduleShipyard_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailHoSo ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentType': filter.documentType,
              'documentName': filter.documentName,
              'documentYear': filter.documentYear,
              'type': filter.type
            }
          }
          axios.get(state.initData.getDetailByDocumentName, param).then(function (response) {
            let serializable = response.data
            commit('setDetailHs', serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            commit('setDetailHs', null)
            reject(error)
          })
        })
      })
    },
    loadFlagStateOfShip ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getFlagStateOfShip, {}).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadShipOwner ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getShipOwner, {}).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDataItems ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getDataItems, param).then(function (response) {
            let serializable = response.data['data']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDataDm ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          if (data.hasOwnProperty('portOfAuthority') && !data['portOfAuthority'] || data.hasOwnProperty('portofAuthority') && !data['portofAuthority']) {
            param.params['portOfAuthority'] = state.maritimeCode
            param.params['portofAuthority'] = state.maritimeCode
          }
          if (data.hasOwnProperty('maritimeCode') && !data['maritimeCode']) {
            param.params['maritimeCode'] = state.maritimeCode
          }
          axios.get(state.initData.getDetailDmCategories, param).then(function (response) {
            let serializable = response.data['data']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getDmGtReportCategories ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['getDmGtReportCategoriesURL'], param).then(function (response) {
            let serializable = response['data']
            if (serializable['data']) {
              resolve(serializable['data'])
            } else {
              resolve([])
            }
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    checkHistoryTempDebitnote ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['checkHistoryTempDebitnoteURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xacBaoTinhPhiTauDichVu ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['xacBaoTinhPhiTauDichVuURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xacBaoTinhPhiTauChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['xacBaoTinhPhiTauChuyenTuyenURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xacBaoTinhPhiTauBien_PTTND ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['xacBaoTinhPhiTauBien_PTTNDURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xemBangKeTauDichVu ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['xemBangKeTauDichVuURL'], param).then(function (response) {
            let serializable = response.data['url']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xemBangChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['xemBangKeTauChuyenTuyenURL'], param).then(function (response) {
            let serializable = response.data['url']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xemGiayBaoTinhPhi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['phieuBaoThuPhiURL'], param).then(function (response) {
            let serializable = response.data['url']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDataTugboat ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {
            categoryId: 'DM_VMA_TUGBOAT'
          }
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          if (data.hasOwnProperty('portOfAuthority') && !data['portOfAuthority'] || data.hasOwnProperty('portofAuthority') && !data['portofAuthority']) {
            param.params['portOfAuthority'] = state.maritimeCode
            param.params['portofAuthority'] = state.maritimeCode
          }
          if (data.hasOwnProperty('maritimeCode') && !data['maritimeCode']) {
            param.params['maritimeCode'] = state.maritimeCode
          }
          axios.get(state.initData.getDetailDmCategories, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDataDmSync ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getDmSyncCategories, param).then(function (response) {
            let serializable = response.data['data']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDataDmDetail ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: {}
        }
        for (var key in data) {
          param.params[key] = data[key]
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getDetail, param).then(function (response) {
            let serializable = response.data['data']
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadChanelList ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getDetailDmCategories, {
            params: {
              categoryId: 'DM_TUYEN_LUONG'
            }
          }).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaShipId': data.id
            }
          }
          axios.get(state.initData.getVmaShip_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailPTTND ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaShipId': data.id
            }
          }
          axios.get(state.initData.getVmaShip_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailHoaTieuDanTauFromItinerary ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              start: 0,
              end: 15,
              ...data
            }
          }
          axios.get(state.initData.getVmaSchedulePilotURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailNhapTachDoanFromItinerary ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              start: 0,
              end: 15,
              ...data
            }
          }
          axios.get(state.initData.getVmaScheduleMergingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailNhapTachDoan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleMergingId': data.id,
              'documentType': data.documentType,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          }
          axios.get(state.initData.getVmaScheduleMerging_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailHoaTieuDanTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaSchedulePilotId': data.id,
              'documentType': data.documentType,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          }
          axios.get(state.initData.getVmaSchedulePilot_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailTauNeoDau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleAnchorageId': data.id
            }
          }
          axios.get(state.initData.getVmaScheduleAnchorage_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetail_PTTND ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaItineraryScheduleId': data.id
            }
          }
          axios.get(state.initData.getVmaItinerarySchedule_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailTauDenCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaItineraryScheduleId': data.id
            }
          }
          axios.get(state.initData.getVmaItinerarySchedule_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailFromItineraryNo_NoticeShipType ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          console.log('state.initData+++++++++++++', state.initData)
          let param = {
            params: {
              'itineraryNo': data['itineraryNo'],
              'noticeShipType': data['noticeShipType']
            }
          }
          axios.get(state.initData.getVmaItinerary_ItineraryNo_NoticeShipTypeURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailThuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleTestingId': data.id
            }
          }
          axios.get(state.initData.getVmaScheduleTesting_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailTauDiChuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleShiftingId': data.id
            }
          }
          axios.get(state.initData.getVmaScheduleShifting_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadListNhapTachDoanFromItinerary ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              start: 0,
              end: 15,
              ...data
            }
          }
          axios.get(state.initData.getVmaScheduleMergingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetaiTauLaiHoTroFromItinerary ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              start: 0,
              end: 15,
              ...data
            }
          }
          axios.get(state.initData.getVmaScheduleTugboatListURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetaiTauLaiHoTro ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleTugboatId': data.id,
              'documentType': data.documentType,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          }
          axios.get(state.initData.getVmaScheduleTugboat_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailKhangCao ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaItineraryProtestId': data.id,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          }
          axios.get(state.initData.getVmaItineraryProtest_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetaiHangHoaXepDo ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaScheduleCargolistId': data.id
            }
          }
          axios.get(state.initData.getVmaScheduleCargolist_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailTauRoiCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'vmaItineraryScheduleId': data.id
            }
          }
          axios.get(state.initData.getVmaItinerarySchedule_Detail_URL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleXlineSailingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteNhapTachDoan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteScheduleMergingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteKhangCao ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaItineraryProtestURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauLaiHoTro ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleTugboatURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteThuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleTestingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteGiuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleSecurityURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteThaXuong ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleLaunchingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauDiChuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleShiftingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauDenCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addVmaItinerary ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaItineraryURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addHangHoaXD ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleCargolistURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addKhangCao ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaItineraryProtestURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addThaXuong ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleLaunchingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addPTTNDTauDenCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addPTTNDTauDenCang, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          console.log('state.initData.addVmaShipURL++++++++++', state.initData.addVmaShipURL)
          let param = {
            params: data,
            headers: {
            }
          }
          axios.get(state.initData.addVmaShipURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data,
            headers: {
            }
          }
          axios.get(state.initData.deleteTauBien, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateAnchorageListPayment ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateAnchorageListPaymentURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateCargolistListPayment ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateCargolistListPaymentURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateProtestListPayment ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateProtestListPaymentURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateShipPosition ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateShipPositionURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editKhangCao ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['updateVmaItineraryProtestURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editTauNeoDau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleAnchorageURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editGiuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleSecurityURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editThaXuong ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleLaunchingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editSuaChua ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleShipyardURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editNhapTachToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateScheduleMergingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editHoaTieuDanTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaSchedulePilotURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editHangHoaXD ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleCargolistURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getVmaTransactionFunction ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getVmaTransactionFunctionURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    actionKeHoachAllInOne ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.actionKeHoachAllInOneURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getFileThanhPhanVersionList ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getFileThanhPhanVersionList, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getVmaConversionData ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getVmaConversionDataURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getVmaTransactionSlipDetail ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getVmaTransactionSlipDetailURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addVmaTransactionSlipDetail ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaTransactionSlipDetailURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateVmaTransactionSlipDetail ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaTransactionSlipDetailURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editTauLaiHoTro ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleTugboatURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    tinhPhiLaiTauDichVu ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['huyBaoTinhPhiDichVuURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    tinhPhiLaiTauChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['huyBaoTinhPhiChuyenTuyenURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    huytinhphi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['huytinhphiURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    huyTinhPhiTauDichVu ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['huyBaoTinhPhiDichVuURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    huyTinhPhiTauChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData['huyBaoTinhPhiChuyenTuyenURL'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    capNhatListKhangNghi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleProtest_MakePayment_DocumentaryCodeURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    capNhatListHangHoa ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleCargolist_MakePayment_DocumentaryCodeURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    capNhatListNeo ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleAnchoragePortURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xacnhantinhphi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.xacnhantinhphiURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    sotienphainop ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.sotienphainopURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    xacnhanthanhtoan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.xacnhanthanhtoanURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    nopTien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.noptienURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    rutquy ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.rutquyURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    napquy_dunodauky ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.napquy_dunodaukyURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editTauBien ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaShipURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteHangHoaXD ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleCargolistURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteHoaTieuDanTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaSchedulePilotURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauRoiCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteTauNeoDau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleAnchorageURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deletePTTNDTauDenCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteSuaChua ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaScheduleShipyardURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deletePTTNDTauRoiCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deletePhuongTienThuyNoiDia ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.deletePhuongTienThuyNoiDia, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editPhuongTienThuyNoiDia ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaShipURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addPhuongTienThuyNoiDia ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data,
            headers: {
            }
          }
          axios.get(state.initData.addVmaShipURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addGiuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleSecurityURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addSuaChua ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleShipyardURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addTauChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        console.log('chanelCodeList+++++++++++', data)
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleXlineSailingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addThuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let chanelCodeList = ''
        console.log('chanelCodeList+++++++++++', data)
        let param = {
          params: data,
          headers: {
          }
        }
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join()
            param.params['chanelCodeList'] = chanelCodeList
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleTestingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addTauDiChuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let chanelCodeList = ''
        console.log('chanelCodeList+++++++++++', data)
        let param = {
          params: data,
          headers: {
          }
        }
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join()
            param.params['chanelCodeList'] = chanelCodeList
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleShiftingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editTauChuyenTuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleXlineSailingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editThuTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let chanelCodeList = ''
        let param = {
          params: data,
          headers: {
          }
        }
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join()
            param.params['chanelCodeList'] = chanelCodeList
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleTestingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    editTauDiChuyen ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let chanelCodeList = ''
        let param = {
          params: data,
          headers: {
          }
        }
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join()
            param.params['chanelCodeList'] = chanelCodeList
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaScheduleShiftingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addTauRoiCang ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addTauRoiCang, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addTauNeoDau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleAnchorageURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addTauLaiHoTro ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaScheduleTugboatURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addNhapTachDoan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addScheduleMergingURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addHoaTieuDanTau ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaSchedulePilotURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    // addVmaItinerary ({commit, state}, data) {
    //   return new Promise((resolve, reject) => {
    //     let param = {
    //       params: data,
    //       headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //       }
    //     }
    //     store.dispatch('loadInitResource').then(function (result) {
    //       axios.get(state.initData.addVmaItineraryScheduleURL, param).then(function (response) {
    //         let serializable = response.data
    //         resolve(serializable)
    //       }).catch(function (error) {
    //         console.log(error)
    //         reject(error)
    //       })
    //     })
    //   })
    // },
    autoFillCargolist ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.autoFillCargolistURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addVmaItinerarySchedule ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let chanelCodeList = ''
        console.log('data +++++++++++++', data)
        let param = {
          params: data,
          headers: {
          }
        }
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join()
            param.params['chanelCodeList'] = chanelCodeList
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateVmaItinerary ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaItineraryURL, param).then(function (response) {
            let serializable = response.data
            commit('setItineraryNo', serializable)
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    addPhieuThanhToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.addVmaTransactionSlip_VmaTransactionSlipDetailURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updatePhieuThanhToan ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaTransactionSlip_VmaTransactionSlipDetailURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailPhiById ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getVmaTransactionSlipDetailURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadDetailPhi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.findVmaTransactionSlipByItineraryNoDocumenttaryCodeURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    tinhPhi ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let param = {
          params: data,
          headers: {
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.doChargeURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    updateVmaItinerarySchedule ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        let chanelCodeList = ''
        console.log('data +++++++++++++', data)
        let param = {
          params: data,
          headers: {
          }
        }
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join()
            param.params['chanelCodeList'] = chanelCodeList
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.updateVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    deleteItemTable ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          for (var key in data) {
            if (key !== 'url') {
              param.params[key] = data[key]
            }
          }
          axios.get(data['url'], param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadKhaiBaoHoSo ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear
            }
          }
          axios.get(state.initData.getThongTinKhaiBaoTable, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getCheckActiveVma ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.checkActiveVmaURL, {}).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadItineraryFromItineraryNo ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: filter
          }
          axios.get(state.initData.getVmaItineraryByItineraryNoURL, param).then(function (response) {
            let serializable = response.data
            // console.log('ItineraryNo----------+++++++++++', serializable)
            if (serializable.hasOwnProperty('itineraryNo')) {
              commit('setItineraryNo', serializable)
            } else {
              commit('setItineraryNo', {})
            }
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            commit('setItineraryNo', {})
            reject(error)
          })
        })
      })
    },
    loadItineraryNo ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentName': filter.documentName,
              'documentYear': filter.documentYear
            }
          }
          axios.get(state.initData.getVmaItineraryNoURL, param).then(function (response) {
            let serializable = response.data
            // console.log('ItineraryNo----------+++++++++++', serializable)
            if (serializable.hasOwnProperty('itineraryNo')) {
              commit('setItineraryNo', serializable)
            } else {
              commit('setItineraryNo', {})
            }
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            commit('setItineraryNo', {})
            reject(error)
          })
        })
      })
    },
    loadInitData ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          if (!state.itineraryNo) {
            store.dispatch('loadItineraryNo', {
              'documentName': filter.documentName,
              'documentYear': filter.documentYear
            }).then(resultItineraryNo => {
              let param = {
                params: {
                  'itineraryNo': resultItineraryNo.hasOwnProperty('itineraryNo') ? resultItineraryNo['itineraryNo'] : '',
                  'documentName': filter.documentName,
                  'documentYear': filter.documentYear
                }
              }
              axios.get(state.initData.setVmaInitScheduleURL, param).then(function (response) {
                let serializable = response.data
                resolve(serializable)
              }).catch(function (error) {
                console.log(error)
                reject(error)
              })
            })
          } else {
            let param = {
              params: {
                'itineraryNo': state.itineraryNo ? state.itineraryNo['itineraryNo'] : '',
                'documentName': filter.documentName,
                'documentYear': filter.documentYear
              }
            }
            axios.get(state.initData.setVmaInitScheduleURL, param).then(function (response) {
              let serializable = response.data
              resolve(serializable)
            }).catch(function (error) {
              console.log(error)
              reject(error)
            })
          }
        })
      })
    },
    getExchangeRate ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData.getTyGiaURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getLastVmaItinerarySchedule ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: data
          }
          axios.get(state.initData.getLastVmaItineraryScheduleURL, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadMessageType23EXT ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear
            }
          }
          axios.get(state.initData.getMessageType23EXT, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadPhanHoi ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear
            }
          }
          axios.get(state.initData.getPhanHoiTuCoQuanChuyenNganhTable, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadGhiChu ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear,
              'ministryCode': filter.ministryCode
            }
          }
          axios.get(state.initData.exportPDFDetail, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    loadUserSigns ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'documentType': filter.documentType,
              'documentName': filter.documentName,
              'documentYear': filter.documentYear,
              'messageType': filter.messageType,
              'REQUEST_CODE': filter.requestCode,
              'roleType': filter.roleType
            }
          }
          axios.get(state.initData.checkThanhPhanActionButton, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getListPortWharf ({commit, state}, filter) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          let param = {
            params: {
              'harbourCode': filter.harbourCode,
              'documentName': filter.documentName,
              'documentYear': filter.documentYear
            }
          }
          axios.get(state.initData.getListPortWharf, param).then(function (response) {
            let serializable = response.data
            resolve(serializable)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    },
    getTinMois ({commit, state}) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          axios.get(state.initData.getNotifications).then(function (response) {
            let serializable = response.data
            resolve(serializable.data)
          }).catch(function (error) {
            console.log(error)
            reject(error)
          })
        })
      })
    }
  },
  mutations: {
    setDrawer (state, payload) {
      state.drawer = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setLoadingTable (state, payload) {
      state.loadingTable = payload
    },
    setLoadingSubmit (state, payload) {
      state.loadingSubmit = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setInitData (state, payload) {
      state.initData = payload
    },
    clearError (state) {
      state.error = null
    },
    setCounterThongBaoPhi (state, payload) {
      state.counterThongBaoPhi = payload
    },
    setCounterDaXuLy (state, payload) {
      state.counterDaXuLy = payload
    },
    setDocTypes (state, payload) {
      state.docTypes = payload
    },
    setRoleFilterStatus (state, payload) {
      state.roleFilterStatus = payload
    },
    setOtherData (state, payload) {
      state.otherData = payload
    },
    setItineraryNo (state, payload) {
      window.sessionStorage.setItem('itineraryNo', JSON.stringify(payload))
      state.itineraryNo = payload
    },
    setDetailHs (state, payload) {
      state.detailHs = payload
    },
    setMaritimeCode (state, payload) {
      state.maritimeCode = payload
    },
    totalTauDiChuyen (state, payload) {
      window.sessionStorage.setItem('totalTauDiChuyen', JSON.stringify(payload))
      state.totalTauDiChuyen = payload
    },
    setItemFee (state, payload) {
      window.sessionStorage.setItem('itemFee', JSON.stringify(payload))
      state.itemFee = payload
    },
    setSelectTau (state, payload) {
      window.sessionStorage.setItem('selectTau', JSON.stringify(payload))
      state.selectTau = payload
    },
    setSelectTauRoi (state, payload) {
      window.sessionStorage.setItem('selectTauRoi', JSON.stringify(payload))
      state.selectTauRoi = payload
    },
    setKeHoachDen (state, payload) {
      window.sessionStorage.setItem('keHoachDen', JSON.stringify(payload))
      state.keHoachDen = payload
    },
    setPttnd (state, payload) {
      window.sessionStorage.setItem('pttnd', payload)
      state.pttnd = payload
    },
    setSelectPTTND (state, payload) {
      state.selectPTTND = payload
    },
    setSwitch1 (state, payload) {
      state.switch1 = payload
    },
    setNoiChuyenlai (state, payload) {
      state.noiChuyenlai = payload
    }
  },
  getters: {
    initData (state) {
      return state.initData
    },
    loading (state) {
      return state.loading
    },
    itineraryNo (state) {
      var item = state.itineraryNo
      if (item && (Object.keys(item).length !== 0 && item.constructor === Object)) {
        return item
      } else {
        item = window.sessionStorage.getItem('itineraryNo')
        if (item && item !== 'null') {
          try {
            item = JSON.parse(item)
            return item || {}
          } catch (e) {
            item = {}
            console.log(e)
          }
        } else {
          item = {}
        }
      }
      return item
    },
    loadingTable (state) {
      return state.loadingTable
    },
    loadingSubmit (state) {
      return state.loadingSubmit
    },
    loadingInitData (state) {
      return new Promise((resolve, reject) => {
        store.dispatch('loadInitResource').then(function (result) {
          resolve(result)
        })
      })
    },
    selectTau (state) {
      var item = state.selectTau
      if (item && (Object.keys(item).length !== 0 && item.constructor === Object)) {
        return item
      } else {
        item = window.sessionStorage.getItem('selectTau')
        if (item) {
          try {
            item = JSON.parse(item)
            return item || {}
          } catch (e) {
            item = {}
            console.log(e)
          }
        }
      }
      return item
    },
    itemFee (state) {
      var item = state.itemFee
      if (item && (Object.keys(item).length !== 0 && item.constructor === Object)) {
        return item
      } else {
        item = window.sessionStorage.getItem('itemFee')
        if (item) {
          try {
            item = JSON.parse(item)
            return item || {}
          } catch (e) {
            item = {}
            console.log(e)
          }
        } else {
          item = {}
        }
      }
      return item
    },
    keHoachDen (state) {
      var item = state.keHoachDen
      if (item && (Object.keys(item).length !== 0 && item.constructor === Object)) {
        return item
      } else {
        item = window.sessionStorage.getItem('keHoachDen')
        if (item) {
          try {
            item = JSON.parse(item)
            return item || {}
          } catch (e) {
            item = {}
            console.log(e)
          }
        }
      }
      return item
    },
    selectTauRoi (state) {
      var item = state.selectTauRoi
      if (item && (Object.keys(item).length !== 0 && item.constructor === Object)) {
        return item
      } else {
        item = window.sessionStorage.getItem('selectTauRoi')
        if (item) {
          try {
            item = JSON.parse(item)
            return item || {}
          } catch (e) {
            item = {}
            console.log(e)
          }
        }
      }
      return item
    },
    pttnd (state) {
      var item = (window.sessionStorage.getItem('pttnd') === 'true')
      if (item === null || item === undefined || item === '' || item === 'undefined') {
        return false
      }
      return item
    },
    totalTauDiChuyen (state) {
      var item = state.totalTauDiChuyen
      if (!item) {
        return item
      } else {
        item = window.sessionStorage.getItem('totalTauDiChuyen')
        item = parseInt(item)
      }
      return item
    },
    selectPTTND (state) {
      return state.selectPTTND
    },
    error (state) {
      return state.error
    },
    index (state) {
      return state.index
    },
    docTypes (state) {
      if (state.docTypes === null) {
        return new Promise((resolve, reject) => {
          store.dispatch('loadDocTypes').then(function (result) {
            resolve(result)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve(state.docTypes)
        })
      }
    },
    switch1 (state) {
      return state.switch1
    },
    otherData (state) {
      return state.otherData
    },
    roleFilterStatus (state) {
      return (filter) => {
        return new Promise((resolve, reject) => {
          store.dispatch('loadRoleFilterStatus', filter).then(function (result) {
            resolve(result)
          })
        })
      }
    },
    counterThongBaoPhi (state) {
      return state.counterThongBaoPhi
    },
    counterDaXuLy (state) {
      return state.counterDaXuLy
    },
    detailHs (state) {
      return state.detailHs
    },
    drawer (state) {
      return state['drawer']
    },
    noiChuyenlai (state) {
      return state['noiChuyenlai']
    },
    maritimeCode (state) {
      return state['maritimeCode']
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js